import { BillControllerApi } from "@/http/apis/BillControllerApi";
import { UserWalletControllerApi } from "@/http/apis/UserWalletControllerApi";
import { PaymentControllerApi } from "@/http/apis/PaymentControllerApi";
import { BankCardControllerApi } from "@/http/apis/BankCardControllerApi";
import type { BillCreateReqVo, PaymentCreateReqVo } from "@/http/models";

const billApi = new BillControllerApi();
const userWalletApi = new UserWalletControllerApi();
const paymentApi = new PaymentControllerApi();
const bankCardApi = new BankCardControllerApi();

export const depositService = {
  /**
   * 创建存款申请
   */
  async createDeposit(payload: BillCreateReqVo) {
    const res = await billApi.billCreatePost({
      billCreateReqVo: payload,
    });
    return res;
  },

  /**
   * 分页查询账单列表
   */
  async getDepositList(params: {
    currentPage?: number;
    pageSize?: number;
    billType?: number[];
    userId?: number;
    status?: number;
    billCode?: string;
    orderCode?: string;
  }) {
    const res = await billApi.billListGet({
      currentPage: params.currentPage,
      pageSize: params.pageSize,
      billType: params.billType,
      userId: params.userId,
      status: params.status,
      billCode: params.billCode,
      orderCode: params.orderCode,
    });
    return res;
  },

  /**
   * 获取预存款明细列表
   */
  async getWalletDetailList(params: {
    currentPage: number;
    pageSize: number;
    usedType?: number;
    billCode?: string;
    orderCode?: string;
  }) {
    const res = await userWalletApi.userWalletDetailListGet({
      currentPage: params.currentPage,
      pageSize: params.pageSize,
      usedType: params.usedType,
      billCode: params.billCode,
      orderCode: params.orderCode,
    });
    return res;
  },

  /**
   * 获取使用类型选项列表
   */
  async getUsedTypeOptions() {
    const res = await userWalletApi.userWalletUsageOptionsGet({});
    return res?.data || [];
  },

  /**
   * 获取账单详情
   */
  async getBillDetail(id: number) {
    const res = await billApi.billDetailIdGet({ id });
    return res?.data || null;
  },

  /**
   * 获取支付单列表
   */
  async getPaymentList(params: {
    currentPage?: number;
    pageSize?: number;
    userId?: number;
    account?: string;
    billType?: number[];
    billCode?: string;
    orderCode?: string;
  }) {
    const res = await paymentApi.paymentListGet({
      currentPage: params.currentPage,
      pageSize: params.pageSize,
      userId: params.userId,
      account: params.account,
      billType: params.billType,
      billCode: params.billCode,
      orderCode: params.orderCode,
    });
    return res?.data || null;
  },

  /**
   * 创建支付记录
   */
  async createPayment(payload: PaymentCreateReqVo) {
    const res = await paymentApi.paymentCreatePost({
      paymentCreateReqVo: payload,
    });
    return res || null;
  },

  /**
   * 获取马帮通韩国汇款账号
   */
  async getMbtBankAccount() {
    const res = await bankCardApi.bankCardMbtBankAccountGet();
    return res?.data || null;
  },
  /**
   * 获取账单类型枚举列表
   */
  async getBillTypeOptions() {
    const res = await billApi.billBillTypeEnumListGet();
    return res?.data || [];
  },
  /**
   * 根据订单号和账单类型获取账单详情列表
   */
  async getBillDetailList(params: { orderCode: string; billType?: number }) {
    const res = await billApi.billDetailListGet({
      orderCode: params.orderCode,
      billType: params.billType,
    });

    return res?.data || [];
  },
};
